import { ClaraAuthPage } from "../components/ClaraAuthPage";

export const LoginPage = () => {
  return <ClaraAuthPage type="login" rememberMe={false} registerLink={false} />;
};
